























import { defineComponent, computed } from '@vue/composition-api';

export default defineComponent({
    name: 'Tab',
    props: {
        tab: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
        activeTab: {
            type: Number,
            required: true,
        },
        lastElement: {
            type: Boolean,
            default: false,
        },
        clickable: {
            type: Boolean,
            default: false,
        },
        breadcrumbMode: {
            type: Boolean,
            default: true,
        },
        totalTabs: {
            type: Number,
            required: true,
        },
        compact: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, { emit }) {
        const currentlyActive = computed(() => props.index === props.activeTab);

        // In breadcrumb mode earlier steps are completed; otherwise a tab is only current or upcoming.
        const status = computed(() => {
            if (currentlyActive.value) return 'current';
            if (props.breadcrumbMode && props.index < props.activeTab) return 'complete';
            return 'upcoming';
        });

        const railFilled = computed(() => status.value !== 'upcoming');

        const tabClicked = () => {
            if (props.clickable) {
                emit('click', props.index);
            }
        };
        return { currentlyActive, status, railFilled, tabClicked };
    },
});
